/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService, AuthStoreService, LogService } from '../../../../core/services';
import { Injectable } from '@angular/core';
import { ModulesEnum } from '../../../../core/enums';
import { Observable } from 'rxjs';
import { TimeZoneEnum } from '../enums/api';

@Injectable()
export class DateTimeApiService {

    constructor(
        private apiService: ApiService,
        private authStoreService: AuthStoreService,
        private logService: LogService,
    ) {
    }

    /**
     * Get date and time details via the API
     * @returns {any}
     */
    public getNodeDateTime(options?: any) {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            this.apiService.get(
                TimeZoneEnum.GET_DATETIME,
                moduleAuth,
                true
            ).subscribe(
                data => {
                    observer.next(data);
                    observer.complete();
                },
                error => {
                    this.logService.error('dateTimeService:getDateTime()', 'Failed to get date and time from the API');
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * Sets timezone via API
     * @param timezone
     * @param options
     */
    public addTimeZone(timezone, options?: any) {
        return new Observable((observer) => {
                // Get our selected module details
                const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

                this.apiService.put(
                    TimeZoneEnum.PUT_DATETIME_TIMEZONE,
                    JSON.stringify({ zone: timezone }),
                    moduleAuth,
                    true
                ).subscribe(
                    response => {
                        observer.next(response);
                        observer.complete();
                    },
                    error => {
                        observer.error(error);
                        observer.complete();
                    }
                );
            }
        );
    }

    /**
     * Get the full list of timezones from the API
     * @param options
     */
    public getTimeZones(options?: any) {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            this.apiService.get(
                TimeZoneEnum.GET_TIMEZONES,
                moduleAuth,
                false
            ).subscribe(
                data => {
                    observer.next(data);
                    observer.complete();
                },
                error => {
                    this.logService.error('dateTimeService:getTimeZones()', 'Fail to getTimeZones() API');
                    observer.error(error);
                    observer.complete();
                }
            );
        });

    }

    /**
     * Sets NTP vis the API
     * @param data
     * @param options
     */
    public addNtp(data, options?: any) {
        return new Observable(observer => {
                // Get our selected module details
                const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

                this.apiService.put(
                    TimeZoneEnum.PUT_DATETIME_NTP,
                    data,
                    moduleAuth,
                    true
                ).subscribe(
                    response => {
                        observer.next(response);
                        observer.complete();
                    },
                    error => {
                        observer.error(error);
                        observer.complete();
                    }
                );
            }
        );
    }

    /**
     * Sets time and date via API
     * @param time
     * @param date
     * @param options
     */
    public addTimeDate(time, date, options?: any) {
        return new Observable(observer => {
                // Get our selected module details
                const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

                this.apiService.put(
                    TimeZoneEnum.PUT_DATETIME,
                    JSON.stringify({
                        dateTime: date + 'T' + time + 'Z'
                    }),
                    moduleAuth,
                    true
                ).subscribe(
                    response => {
                        observer.next(response);
                        observer.complete();
                    },
                    error => {
                        observer.error(error);
                        observer.complete();
                    }
                );
            }
        );
    }
}
